module.exports = __webpack_public_path__ + "assets/img/tech-10.7efe5e9a.svg";